module.exports = __webpack_public_path__ + "images/0b05eec1aa05be6d4db8989f7126c4cc-haven.png";